export default {
	namespaced: true,
	state: {
		list: [],
		accountants: [],
		permissions: [],
		members: [],
		listMemberUsers: [],

		loanApplications: [],
		totalMembers: 0,
		totalAccountants: 0,
		totalLoanApplications: 0,
		totalPayments: 0,
	},

	mutations:{
		/**
		 * [setTotalPayments description]
		 * @param {[type]} state    [description]
		 * @param {[type]} payments [description]
		 */
		setTotalPayments(state, payments) {
			state.totalPayments=payments
		},

		/**
		 * [setTotalLoanApplications description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setTotalLoanApplications(state, payload) {
			state.totalLoanApplications= payload
		},

		/**
		 * [setTotalAccountants description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setTotalAccountants(state, num_accountant) {
			state.totalAccountants=num_accountant
		},

		/**
		 * [setTotalMembers description]
		 * @param {[type]} state         [description]
		 * @param {[type]} total_members [description]
		 */
		setTotalMembers(state, total_members) {
			state.totalMembers=total_members
		},

		/**
		 * [setLoanApplications description]
		 * @param {[type]} state        [description]
		 * @param {[type]} applications [description]
		 */
		setLoanApplications(state, applications) {
			state.loanApplications=applications
		},

		/**
		 * [updateMember description]
		 * @param  {[type]} state  [description]
		 * @param  {[type]} member [description]
		 * @return {[type]}        [description]
		 */
		updateMember(state, member) {
			let isUpdated= false
			for (var i = 0; i<state.members.length; i++) {
				if(state.members[i].id==member.id) {
					isUpdated=true
					state.members[i]=member
					break;
				}
			}

			if(!isUpdated) {
				state.members.push(member)
			}
		},

		/**
		 * [addMember description]
		 * @param {[type]} state  [description]
		 * @param {[type]} member [description]
		 */
		addMember(state, member) {
			state.members.push(member)
		},

		/**
		 * [setMembers description]
		 * @param {[type]} state   [description]
		 * @param {[type]} members [description]
		 */
		setMembers(state, members) {
			state.members=members
		},

		/**
		 * [setPermissions description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setPermissions(state, payload) {
			state.permissions=payload
		},

		/**
		 * [deleteAccountant description]
		 * @param  {[type]} state      [description]
		 * @param  {[type]} account_id [description]
		 * @return {[type]}            [description]
		 */
		deleteAccountant(state, account_id) {
			for (let i = 0; i < state.accountants.length; i++) {
				if(state.accountants[i].id==account_id) {
					state.accountants.splice(i, 1);
					break
				}
			}
		},

		/**
		 * [updateAccountant description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		updateAccountant(state, payload) {
			for (let i = 0; i < state.accountants.length; i++) {
				if(state.accountants[i].id==payload.id) {
					state.accountants[i]=payload
					break
				}
			}
		},

		/**
		 * [addAccountant description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addAccountant(state, payload) {
			state.accountants.push(payload)
		},

		/**
		 * [setAccountants description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setAccountants(state, payload) {
			state.accountants=payload
		},

		/**
		 * [setList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		setList(state, payload){
			state.list=payload
		},
		
		/**
		 * [setLisMemberUsers description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		 setListMemberUsers(state, payload){
			state.listMemberUsers=payload
		},



		/**
		 * [addList description]
		 * @param {[type]} state   [description]
		 * @param {[type]} payload [description]
		 */
		addList(state, payload){
			state.list.push(payload)
		},
	},
	getters:{
		/**
		 * [totalPayments description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		totalPayments(state) {
			return state.totalPayments
		},
		
		/**
		 * [totalLoanApplications description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		totalLoanApplications(state) {
			return state.totalLoanApplications
		},

		/**
		 * [totalAccountants description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		totalAccountants(state) {
			return state.totalAccountants
		},

		/**
		 * [totalMembers description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		totalMembers(state) {
			return state.totalMembers
		},
		/**
		 * [totalMembers Users description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		totalMemberUsers(state) {
			return state.listMemberUsers
		},

		/**
		 * [loanApplications description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		loanApplications(state) {
			return state.loanApplications
		},

		/**
		 * [members description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		members(state) {
			return state.members
		},

		/**
		 * [permissions description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		permissions(state) {
			return state.permissions
		},

		/**
		 * [accountants description]
		 * @param  {[type]} state   [description]
		 * @param  {[type]} payload [description]
		 * @return {[type]}         [description]
		 */
		accountants(state, payload) {
			return state.accountants
		},

		/**
		 * [getList description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		
		getList(state) {
			return state.list
		},
		/**
		 * [getList description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		
		getListMemberUsers(state) {
			return state.listMemberUsers
		},

		/**
		 * [getById description]
		 * @param  {[type]} state [description]
		 * @return {[type]}       [description]
		 */
		getById(state) {
			return (id) => {
				return state.list.find(item => item.id===id)||{}
			}
		}
	},
	actions: {
		/**
		 * [downloadRequirements description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		downloadRequirements({commit, getters}, application_id) {
			return this._vm.$http.get('loan-applications/coop/member-loan/print-requirements/'+application_id, {
				responseType: 'blob'
			})
				.then(response => response.data)
		},
		/**
		 * [saveEmailTemplate description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} form            [description]
		 * @return {[type]}                 [description]
		 */
		saveEmailTemplate({commit, getters}, form) {
			return this._vm.$http.post('coops/setting/email-template/save-setup', form)
				.then(response => response.data)
		},
		/**
		 * [saveMemberInfo description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} form            [description]
		 * @return {[type]}                 [description]
		 */
		saveMemberInfo({commit, getters}, {account_id, form}) {
			return this._vm.$http.post('coops/members/info/'+account_id+'/save', form)
				.then(response => response.data)
		},
		/**
		 * [getMemberInfo description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} account_id      [description]
		 * @return {[type]}                 [description]
		 */
		getMemberInfo({commit, getters}, account_id) {
			return this._vm.$http.get('coops/members/info/'+account_id)
				.then(response => response.data)
		},
		/**
		 * [previewPromisory description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		previewPromisory({commit, getters}) {
			return this._vm.$http.get('loan-applications/coop/document/preview/loan-promisory', {
				responseType: 'blob'
			})
				.then(response => response.data)
		},
		/**
		 * [saveDocSetup description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} form            [description]
		 * @return {[type]}                 [description]
		 */
		saveDocSetup({commit, getters}, form) {
			return this._vm.$http.post('coops/setting/document/save-setup', form)
				.then(response => response.data)
		},
		/**
		 * [saveLoanAppFormTemplate description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} form            [description]
		 * @return {[type]}                 [description]
		 */
		// saveLoanAppFormTemplate({commit, getters}, form) {
		// 	return this._vm.$http.post('coops/setting/document/loan-application-form', form)
		// },
		/**
		 * [previewLoanAppForm description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		previewLoanAppForm({commit, getters}) {
			return this._vm.$http.get('loan-applications/coop/document/preview/loan-application-form', {
				responseType: 'blob'
			})
				.then(response => response.data)
		},
		/**
		 * [downloadLoanAppForm description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		downloadLoanAppForm({commit, getters}, application_id) {
			return this._vm.$http.get('loan-applications/coop/member-loan/loan-app-form/'+application_id, {
				responseType: 'blob'
			})
				.then(response => {
					const filename = response.headers.get('content-disposition').match(/(filename=")(.*)(\")$/)[2]
					response.data.name=filename
					return response.data
				})
		},
		/**
		 * [save_pdf_setting description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} form            [description]
		 * @return {[type]}                 [description]
		 */
		save_pdf_setting({commit, getters}, form) {
			return this._vm.$http.post('coops/save-pdf-setting', form)
				.then(response => response.data)
		},
		/**
		 * [membership_cancel description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} membership_id   [description]
		 * @return {[type]}                 [description]
		 */
		membership_cancel({commit, getters}, {id, remarks}) {
			return this._vm.$http.post('membership/administrator/applications/detail/cancel/'+id, {
				remarks
			})
		},

		/**
		 * [membership_appove description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} membership_id   [description]
		 * @return {[type]}                 [description]
		 */
		membership_appove({commit, getters}, membership_id) {
			return this._vm.$http.post('membership/administrator/applications/detail/approve/'+membership_id)
		},

		/**
		 * [get_membership_detail description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} id              [description]
		 * @return {[type]}                 [description]
		 */
		get_membership_detail({commit, getters}, id) {
			return this._vm.$http.get('membership/administrator/applications/detail/'+id)
				.then(response => response.data)
		},

		/**
		 * [get_memberships description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} params          [description]
		 * @return {[type]}                 [description]
		 */
		get_memberships({commit, getters}, params) {
			return this._vm.$http.get('membership/administrator/applications', {
				params
			}).then(response => {
				return response.data
			})
		},

		/**
		 * [get_staffs description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} params          [description]
		 * @return {[type]}                 [description]
		 */
		get_staffs({commit, getters}, params) {
			return this._vm.$http.get('coops/accountants', {
				params})
				.then(response => {
					commit('setTotalAccountants', response.data.totalRecords)
					return response.data
				})
		},

		/**
		 * [add_role_to_member description]
		 * @param {[type]} options.commit  [description]
		 * @param {[type]} options.getters [description]
		 * @param {[type]} form            [description]
		 */
		add_role_to_member({commit, getters}, form) {
			return this._vm.$http.post('coops/accountants/add-staff', form)
				.then(response => response.data)
		},

		/**
		 * [get_members description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		get_members({commit, getters}, search) {
			return this._vm.$http.get('coops/accountants/members', {
				params: {q: search}
			})
				.then(response => response.data)
		},

		/**
		 * [get_accountant_logs description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @return {[type]}                 [description]
		 */
		get_accountant_logs({commit, getters}) {
			return this._vm.$http.get('coops/accountants/logs')
				.then(response => response.data)
		},

		/**
		 * [get_printed_promisory_note description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		get_printed_promisory_note({commit, getters}, {application_id, params}) {
			return this._vm.$http.get('loan-applications/coop/member-loan/printed-promisory/'+application_id, {
				params,
				responseType: 'blob'
			})
				.then(response => {
					const filename = response.headers.get('content-disposition').match(/(filename=")(.*)(\")$/)[2]
					response.data.filename=filename
					return response.data
				})
		},

		/**
		 * [reject_payment description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} transaction_id  [description]
		 * @return {[type]}                 [description]
		 */
		reject_payment({commit, getters}, transaction_id) {
			return this._vm.$http.post('payments/coop/reject/'+transaction_id)
				.then(response => response.data)
		},
		
		/**
		 * [approve_payment description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} transaction_id  [description]
		 * @return {[type]}                 [description]
		 */
		approve_payment({commit, getters}, transaction_id) {
			return this._vm.$http.post('payments/coop/posted/'+transaction_id)
				.then(response => response.data)
		},

		/**
		 * [get_payments description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} params          [description]
		 * @return {[type]}                 [description]
		 */
		get_payments({commit, getters}, params) {
			return this._vm.$http.post('payments/coop/list', params)
				.then(response => response.data)
		},

		/**
		 * [loan_application_grab_copy description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_grab_copy({commit, getters}, application_id) {
			return this._vm.$http.get('loan-applications/coop/member-loan/printed-copy', {
				params: {
					application_id
				},
				responseType: 'blob'
			}).then(response => {
				// console.log(response)
				const filename = response.headers.get('content-disposition').match(/(filename=")(.*)(\")$/)[2]
				response.data.filename=filename
				return response.data
			})
		},

		/**
		 * [loan_application_disbursement description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_disbursement({commit, getters}, application_id) {
			return this._vm.$http.post('loan-applications/coop/disbursement/'+application_id)
				.then(response => response.data)
		},

		/**
		 * [loan_application_validate description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_validate({commit, getters}, application_id) {
			return this._vm.$http.post('loan-applications/coop/validate/'+application_id)
				.then(response => response.data)
		},

		/**
		 * [loan_application_receive description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_receive({commit, getters}, application_id) {
			return this._vm.$http.post('loan-applications/coop/receive/'+application_id, {})
				.then(response => {
					// const filename = response.headers.get('content-disposition').match(/(filename=")(.*)(\")$/)[2]
					// response.data.filename=filename
					return response.data
				})
		},

		/**
		 * [loan_application_release description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_release({commit, getters}, application_id) {
			return this._vm.$http.post('loan-applications/coop/release/'+application_id)
				.then(response => response.data)
		},

		/**
		 * [loan_application_reject description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_reject({commit, getters}, {remarks, application_id}) {
			return this._vm.$http.post('loan-applications/coop/reject/'+application_id, {remarks})
				.then(response => response.data)
		},

		/**
		 * [loan_application_approve description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		loan_application_approve({commit, getters}, {application_id, form, validate, calculate}) {
			// console.log(form)
			const params = []
			if(validate) {
				params.push('validate=true')
			}
			if(calculate) {
				params.push('calculate=true')
			}

			// console.log('params', params)
			return this._vm.$http.post('loan-applications/coop/approve/'+application_id+'?'+params.join('&'), form)
				.then(response => response.data)
		},

		/**
		 * [getMemberLoanApplication description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} application_id  [description]
		 * @return {[type]}                 [description]
		 */
		getMemberLoanApplication({commit, getters}, application_id) {
			return this._vm.$http.get('loan-applications/coop/member-loan/'+application_id)
				.then(response => response.data)
		},

		/**
		 * [getLoanApplications description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getLoanApplications({commit, getters}, params) {
			if(getters['loanApplications'].length) {
				return Promise.resolve(getters['loanApplications'])
			}
			return this._vm.$http.post('loan-applications/coop/loans', params)
				.then(response => {
					commit('setLoanApplications', response.data)
					return response.data
				})
		},

		/*toggleSidebar({state, commit, dispatch}) {
			commit('setIsShowedSidebar', !state.isShowedSidebar)
		}*/

		/**
		 * [getMembers description]
		 * @param  {[type]} options.commit  [description]
		 * @param  {[type]} options.getters [description]
		 * @param  {[type]} payload         [description]
		 * @return {[type]}                 [description]
		 */
		getMembers({commit, getters}, payload) {
			return this._vm.$http.post('coops/members/list', payload)
				.then(response => {
					return response.data
				})
		}
	},

}